export interface ISuscriptionParameter {
  ID: number;
  Name: string;
  Description: string;
  Group: string;
  Value: string;
  Encrypt: boolean;
  Editable: boolean;
  Visible: boolean;
}

export function defaultISuscriptionParameter(): ISuscriptionParameter {
  return {
    ID: 0,
    Name: '',
    Group: '',
    Value: '',
    Description: '',
    Encrypt: false,
    Editable: true,
    Visible: true
  }
}